import chineseFan from '@/views/year2020/landingPage/traditionalLanding/chinese'
import xieyi from '@/views/year2020/landingPage/traditionalLanding/agreement'
import MathFan from '@/views/year2020/landingPage/traditionalLanding/math'
import newChineseFan from '@/views/year2020/landingPage/traditionalLanding/newChinese'
import newMathFan from '@/views/year2020/landingPage/traditionalLanding/newMath'
export default [
  {
    path: '/agreement',
    name: 'agreement',
    component: xieyi,
    description: '协议'
  },
  {
    path: '/oversea-chinese-fan',
    name: 'traditionalChinese',
    component: chineseFan,
    description: '海外语文繁体落地页'
  },
  {
    path: '/oversea-math-fan',
    name: 'traditionalMath',
    component: MathFan,
    description: '海外数理繁体落地页'
  },
  {
    path: '/oversea-chinese-fanti',
    name: 'traditionalChineseTi',
    component: newChineseFan,
    description: '海外语文繁体落地页'
  },
  {
    path: '/oversea-math-fanti',
    name: 'traditionalMathTi',
    component: newMathFan,
    description: '海外数理繁体落地页'
  }
]
